module.exports = __webpack_public_path__ + "img/158.289c5731.jpg";